<template>
  <admin-base
    add-btn-text="Add New Permission"
    :add-btn-permission="addPermission"
    @create="create"
    @search="val => search = val"
  >

  <admin-permissions-table
    ref="table"
    :search="search"
    @edit="showPermissionModal"
    @delete="showDeletePermissionDialog"
  />
  <permissions-modal-form
    ref="permissionModal"
    @success="refreshTable"
  />
  <permission-delete-dialog
    :permission="permissionToDelete"
    @closeDialog="hideDeletePermissionDialog"
    @success="deletePermissionSuccess"
    @fail="deletePermissionFail"
    ref="permissionDeleteDialog"
  />
  </admin-base>
</template>

<script>
import AdminBase from '@/components/admin/Base';
import AdminPermissionsTable from '@/components/admin/controls/permissions/PermissionsTable';
import PermissionDeleteDialog from '@/components/admin/controls/permissions/PermissionDeleteDialog';
import PermissionsModalForm from '@/components/admin/controls/permissions/form/PermissionsModalForm';


export default {
  name: 'AdminControlsPermissionsView',
  components: {
    AdminBase,
    AdminPermissionsTable,
    PermissionDeleteDialog,
    PermissionsModalForm,
  },
  data: () => ({
    search: null,
    permissionToDelete: null,
  }),
  computed: {
    addPermission: vm => vm.$permissions.ADD_PERMISSIONS,
  },
  methods: {
    create() {
      this.$refs.permissionModal.open();
    },
    showPermissionModal(permission) {
      this.$refs.permissionModal.open(permission);
    },
    showDeletePermissionDialog(permission) {
      this.$refs.permissionDeleteDialog.show();
      this.permissionToDelete = permission;
    },
    hideDeletePermissionDialog() {
      this.$refs.permissionDeleteDialog.hide();
      this.permissionToDelete = null;
    },
    refreshTable() {
      this.$refs.table.fetch();
    },
    deletePermissionSuccess() {
      this.$refs.permissionDeleteDialog.hide();
      this.$toast.success('Permission successfully deleted!', { timeout: 3000 });
      this.refreshTable();
    },
    deletePermissionFail(message) {
      this.$refs.permissionDeleteDialog.hide();
      this.$toast.error(message, { timeout: 3000 });
    },
  },
};
</script>
